import type { ChatDetail, ChatThread } from '../model/types';

export function isChatMuted(mutedUntil: Date | null | undefined): boolean {
  return !!mutedUntil && mutedUntil.getTime() > Date.now();
}

export function canSendChatMessages(
  thread: ChatThread | null,
  detail: ChatDetail | null = null,
): boolean {
  const status = detail?.status ?? thread?.status;
  if (status === 'closed') {
    return false;
  }

  const mutedUntil = detail?.mutedUntil ?? thread?.mutedUntil ?? null;
  return !isChatMuted(mutedUntil);
}

export function resolveCanLeave(thread: ChatThread | null, detail: ChatDetail | null = null): boolean {
  if (typeof detail?.canLeave === 'boolean') {
    return detail.canLeave;
  }

  return thread?.canLeave ?? false;
}
